import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CARD } from '../ui';
import { formatSubmittedAt } from '../dateFormat';

const RecentActivity = ({ items, showSubmitter }) => {
  const navigate = useNavigate();

  return (
    <div className={`${CARD} overflow-hidden`}>
      <div className="px-6 py-5 border-b border-gray-700 flex items-center justify-between gap-3">
        <h2 className="text-lg font-semibold text-white">Latest submissions</h2>
        <button
          type="button"
          onClick={() => navigate('/forms')}
          className="bg-gray-700/50 hover:bg-gray-600/50 text-gray-300 hover:text-white px-3 py-1.5 rounded-lg text-xs font-medium transition-colors duration-200 border border-gray-600 hover:border-gray-500 flex-shrink-0"
        >
          All forms
        </button>
      </div>

      {items.length === 0 ? (
        <p className="px-6 py-10 text-center text-sm text-gray-500">
          Nothing submitted in this period.
        </p>
      ) : (
        <ul className="divide-y divide-gray-700/60">
          {items.map((item) => (
            <li key={item.id}>
              <button
                type="button"
                onClick={() => navigate(`/submitted/${item.id}`)}
                className="w-full text-left bg-transparent px-6 py-3 hover:bg-gray-700/30 transition-colors duration-200 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-purple-400"
              >
                <div className="flex items-center gap-2 flex-wrap">
                  <span className="text-sm font-medium text-white truncate">
                    {item.title || item.form_name || `Form #${item.form_id}`}
                  </span>
                  {item.parent_submission_id && (
                    <span className="text-xs px-2 py-0.5 rounded-full bg-amber-500/15 text-amber-300 border border-amber-500/30">
                      Re-submission
                    </span>
                  )}
                </div>
                <div className="flex items-center gap-2 mt-0.5 text-xs text-gray-500 flex-wrap">
                  {showSubmitter && item.user_email && <span>{item.user_email}</span>}
                  <span>{formatSubmittedAt(item.submitted_at, item.submitted_tz)}</span>
                </div>
              </button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default RecentActivity;
